export default __webpack_public_path__ + "static/media/wallet.eceab080.svg";